import type { RedoAdminAgentsRpcClient } from "@redotech/admin-agents-sdk/rpc/client";
import { createAdminAgentsRpcClient } from "@redotech/admin-agents-sdk/rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";
import { getTargetAddressSpace } from "../../app/target-address-space";

export const RedoAdminAgentsRpcClientContext: Context<
  RedoAdminAgentsRpcClient | undefined
> = createContext<RedoAdminAgentsRpcClient | undefined>(undefined);
RedoAdminAgentsRpcClientContext.displayName = "RedoAdminAgentsRpcClientContext";

export function RedoAdminAgentsRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoAdminAgentsRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    const targetAddressSpace = getTargetAddressSpace();
    return createAdminAgentsRpcClient({
      baseURL: new URL(
        `${baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl}/admin-agents-rpc`,
      ),
      headers: { Authorization: `Bearer ${authToken}` },
      ...(targetAddressSpace && { targetAddressSpace }),
    });
  }, [baseUrl, authToken]);
  return (
    <RedoAdminAgentsRpcClientContext.Provider value={redoAdminAgentsRpcClient}>
      {children}
    </RedoAdminAgentsRpcClientContext.Provider>
  );
}
